import { CaptionsFrame } from 'captions/CaptionsFrame';
import { ModalType } from 'data/ModalData';
import {
  ADD_FRAME,
  closeModal,
  createTextFrame,
  openModal,
  selectFrame
} from 'state/actions';
import { getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { pause } from 'utils';
import { getSpokenLanguage } from 'utils/Transcribe';
import { AddFrameCommand } from './AddFrameCommand';
import { CommandFunction } from './Command';

export class AddCaptionsFrameCommand extends AddFrameCommand {
  execute(firstTime?: boolean): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { app, flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const frame = await createTextFrame(app, flyer, true, layer);
      frame.id = this.frameId;
      if (flyer.captions) {
        (frame as CaptionsFrame).tokens = flyer.captions;
      }
      if (firstTime) {
        dispatch(closeModal());
        await pause(1);
      }
      dispatch({
        type: ADD_FRAME,
        frame,
        layer,
        layerId: this.layerId
      });
      if (firstTime) {
        await pause(1);
        if (flyer.captions) {
          dispatch(selectFrame(frame));
        } else {
          dispatch(
            openModal(ModalType.CaptionsEditing, {
              audioBuffer: flyer.soundtrack!.audioBuffer,
              initialTokens: flyer.captions ?? undefined,
              initialLanguageCode:
                flyer.captionsLanguageCode ?? getSpokenLanguage(app.user)
            })
          );
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/AddCaptionsFrameCommand.ts